module.exports = __webpack_public_path__ + "static/hospital_support_card_img2@2x-ed381744ca3f98d5541654e80bf39a7d.jpg";